import { LocalizationService } from "../../ShellCommon/localization/localization";
import { EntryStateService } from "../sdServices/authentication/entry-state-service";

const serviceDeskAppId = "ServiceDesk";
const errorMessageTitleKey = "_ERROR_TITLE_PAGE_CAN_NOT_BE_FOUND_";
const errorMessageSubheadKey = "_ERROR_SUBHEAD_PAGE_CAN_NOT_BE_FOUND_";
const linkDisplaynameKey = "_LINK_GO_HOME_";
export class NotFoundController {
  public errorMessageTitle: string;
  public errorMessageSubhead: string;
  public linkDisplayname: string;
  // @ngInject
  constructor(
    private entryStateService: EntryStateService,
    private $scope: ng.IScope,
    private sdLocalizationService: LocalizationService
  ) {
    sdLocalizationService.whenReady(serviceDeskAppId).finally(() => {
      $scope.$applyAsync(() => {
        this.errorMessageTitle = sdLocalizationService.getLocalizedString(serviceDeskAppId, errorMessageTitleKey);
        this.errorMessageSubhead = sdLocalizationService.getLocalizedString(serviceDeskAppId, errorMessageSubheadKey);
        this.linkDisplayname = sdLocalizationService.getLocalizedString(serviceDeskAppId, linkDisplaynameKey);
      });
    });
  }

  public goHome() {
    this.entryStateService.goToEntryState();
  }
}
